import { lazyInject } from '../../../services/inversify';
import { StructureService } from '../../../services/structure_service';
import { WFormConfig } from '../config/WFormConfig';
import { WFormConfigItem } from '../config/WFormConfigItem';
import { WFormConfigItemOption } from '../config/WFormConfigItemOption';
import { DataService } from '../../../services/data_service';
import { RechteService } from '../../../services/rechte_service';
import { IDs } from '../../../helpers/IDs';
import { onStructureReceiveForTable } from './structure_tool_on_reveive_for_table';
import { i18n } from '../../../i18n/i18n';

export class StructureTool {

    constructor(modul: string, globalData?: any) {
        this.globalData = globalData;
        this.modul = modul;
        // console.log('New Structure-Tool: ' + modul)
    }

    public modul: string;
    private globalData: any;

    @lazyInject(StructureService) private structureService: StructureService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(RechteService) private rechteService: RechteService;

    public getStructure(modul: string, key: string) {
        // console.log('GETTING STRUCTURE: ', modul, key);
        if (!modul) {
            modul = this.modul;
        }
        return this.structureService.getStructureByKey(modul, key);
    }

    public getStructureAllByModul(modul: string) {
        return this.structureService.getStructureAllByModul(modul);
    }

    public addStructure(modul: string, key: string, struct: any) {
        if (!modul) {
            modul = this.modul;
        }
        return this.structureService.addStructureByKey(modul, key, struct);
    }

    public getStructureByModul(modul: string, callback: (structure: ReadonlyArray<any>) => void, filter?: boolean) {
        const useFilter = filter || false;
        this.structureService.getStructure(modul, callback, useFilter);
    }

    public generateFormConfig(entity: string, callback: (formConig: WFormConfig) => void) {
        this.structureService.getStructure(this.modul, (data: any) => {
            this.onStructureReceiveForForm(entity, data, callback);
        }, false);
    }

    public generateFormConfigFromStructure(entity: string, structure: any, callback: (formConig: WFormConfig) => void) {
        this.onStructureReceiveForForm(entity, structure, callback);
    }

    public hasAttRecht(att: any) {
        if (typeof att.RECHT === 'string') {
            // console.log(att.RECHT);
            // return false;
            return this.rechteService.hasRecht(att.RECHT);
        }
        return true;
    }

    onStructureReceiveForForm(entity: string, data: any, callback: (formConfig: WFormConfig) => void) {
        const ent = data.hasOwnProperty(entity) ? data[entity] : null;
        const bereich_key = (this.globalData && this.globalData[IDs.ENT_UNTERNEHMENSDATEN] && this.globalData[IDs.ENT_UNTERNEHMENSDATEN][0]) ?
            this.globalData[IDs.ENT_UNTERNEHMENSDATEN][0].bereich_key_orig : null;
        // console.log('STRUKT: ', entity, ent);
        if (ent) {
            const atts: ReadonlyArray<any> = ent.ATTS;
            const formConfig = new WFormConfig();
            formConfig.name = ent.TITEL;
            atts.forEach((att) => {
                const typ = this.resolveType(att.TYPE, att.OPTS, att);
                const item: WFormConfigItem = {
                    key: att.KEY,
                    id: att.ID,
                    label: i18n(att.NAME, `entity.${entity}`),
                    typ: typ,
                    format: att.FORMAT
                };
                if (att.OPTS && att.OPTS.ENTITY && att.OPTS.IDENTIFIER && att.OPTS.INPUT) {
                    item.bundle_text_unique = att.OPTS.UNIQUE_NAME;
                    item.bundle_key = att.OPTS.ENTITY;
                    item.bundle_value = att.OPTS.IDENTIFIER;
                    item.bundle_text = att.OPTS.INPUT;
                    item.bundle_assign = att.OPTS.ASSIGN;
                    item.bundle_fields = att.OPTS.SELECT_DIALOG_FIELDS ? att.OPTS.SELECT_DIALOG_FIELDS : undefined;
                    item.bundle_output = att.OPTS.OUTPUT ? att.OPTS.OUTPUT : undefined;
                    item.bundle_output_condition = att.OPTS.OUTPUT_CONDITION ? att.OPTS.OUTPUT_CONDITION : undefined;
                } else if (att.TYPE === 'FILE' && (att.FILEMODE && att.FILEMODE === 'FOTO')) {
                    item.typ = 'foto';
                } else if (att.TYPE === 'FILE' || (att.FILEMODE && att.FILEMODE === 'ARCHIV')) {
                    item.typ = 'archiv';
                } else if (att.OPTS && att.OPTS instanceof Array) {
                    const options: Array<WFormConfigItemOption> = new Array();
                    att.OPTS.forEach((element: any) => {
                        if (!bereich_key || !element.BEREICH || element.BEREICH[bereich_key]) {
                            options.push({ tid: element.VALUE, name: element.TITEL, name2: element.TITEL2, index: element.INDEX, input_group: element.INPUT_GROUP });
                        }
                    });
                    item.options = options;
                }
                if ((att.HIDDEN && (+att.HIDDEN === 1 || att.HIDDEN === true)) ||
                    !this.hasAttRecht(att)) {
                    item.hidden = true;
                }
                if (att.REQUIRED && (+att.REQUIRED === 1 || att.REQUIRED === true ||
                    att.REQUIRED === 'YES' || att.REQUIRED === 'KEY')) {
                    item.required = true;
                }
                if (att.READONLY && (+att.READONLY === 1 || att.READONLY === true || att.READONLY === 'YES')) {
                    item.readonly = true;
                }
                if (att.DISABLED && (+att.DISABLED === 1 || att.DISABLED === true || att.DISABLED === 'YES')) {
                    item.disabled = true;
                }
                if (att.RADIO && (+att.RADIO === 1 || att.RADIO === true || att.RADIO === 'YES')) {
                    item.radio = true;
                }
                if (att.DISABLE_DEFAULT && (+att.DISABLE_DEFAULT === 1 || att.DISABLE_DEFAULT === true || att.DISABLE_DEFAULT === 'YES')) {
                    item.disable_default = true;
                }
                if (att.AS_JA_NEIN && (+att.AS_JA_NEIN === 1 || att.AS_JA_NEIN === true || att.AS_JA_NEIN === 'YES')) {
                    item.asJaNein = true;
                }
                if (att.ALLOW_FUTURE && (+att.ALLOW_FUTURE === 1 || att.ALLOW_FUTURE === true || att.ALLOW_FUTURE === 'YES')) {
                    item.allowFuture = true;
                }
                if (att.MIN_DATE) {
                    item.min_date = att.MIN_DATE;
                }
                if (att.DATE_AUTOFILL_DEAK
                    && (+att.DATE_AUTOFILL_DEAK === 1 || att.DATE_AUTOFILL_DEAK === true || att.DATE_AUTOFILL_DEAK === 'YES')) {
                    item.autofill = false;
                }
                if (typ === 'formula' && att.FORMULA) {
                    item.formula = att.FORMULA;
                }
                if (att.MAX_LENGTH) {
                    item.maxLength = att.MAX_LENGTH;
                }
                if (att.DECIMALS >= 0) {
                    item.decimals = att.DECIMALS;
                }
                if (att.CONFIRM_REQUIRED && (+att.CONFIRM_REQUIRED === 1 || att.CONFIRM_REQUIRED === true ||
                    att.CONFIRM_REQUIRED === 'YES')) {
                    item.confirm_required = true;
                }
                // WKETOOL-94 Für kombinierte Felder
                if (att.COMBINATION_ITEM) {
                    item.combination_item = true;
                }
                if (att.TYPE === 'COMBINATION') {
                    item.combination_fields = att.COMBINATION_FIELDS;
                    item.combination_fields_name = att.COMBINATION_FIELDS_NAME;
                }

                formConfig.addItem(item);
            }
            );
            // console.log(formConfig);
            callback(formConfig);
        } else {
            callback(null);
        }
    }

    public resolveType(type: string, hasOpts: boolean, att: any): any {
        if (hasOpts) {
            if (true || type.toLowerCase() === 'int') { // Das Textselect brauchen wir im E-Tool nicht
                if (att.OPTS.SELECT_DIALOG_FIELDS) {
                    return 'select_dialog';
                }
                return 'select';
            } else {
                return 'textselect';
            }
        }
        if (type.toLocaleLowerCase() === 'text' && att.FORMAT === 'TEXTAREA') {
            return 'textarea';
        }
        switch (type.toLowerCase()) {
            case 'date':
                return 'datepicker';
            case 'datetime':
                return 'datetimepicker';
            case 'int':
                return 'number';
            case 'double':
                return 'number';
            case 'select':
                return 'select';
            case 'mail':
                return 'mail';
            case 'formula':
                return 'formula';
            case 'checkbox':
                return 'checkbox';
            case 'titel':
                return 'titel';
            case 'combination':
                return 'combination';
            default:    // Alles andere ist Text
                if (att.MODE && att.MODE === 'PASSWORD') {
                    return 'password';
                }
                return 'text';
        }
    }
}
